export default __webpack_public_path__ + "static/media/HK.f9774fab.ico";